import {
  getItems,
  getShipping,
  totalAmount,
  getOrder,
  MAX_CART_ITEMS
} from '../../services/shopping-cart'
export default {
  data() {
    return {
      items: [],
      shipping: {},
      totalAmount: 0,
      currency: '',
      maxItems: MAX_CART_ITEMS
    }
  },
  mounted() {
    let order = getOrder()
    this.items = getItems().items
    if (order) this.currency = order.currency
    else this.currency = 'htg'
    this.shipping = getShipping()
    this.totalAmount = totalAmount()
  },
  methods: {
    nextStep() {
      if (this.$parent.loggedIn) {
        this.$parent.activeStep += 2
      } else {
        this.$parent.activeStep++
      }
    }
  },
  filters: {
    uppercase(val) {
      if (!val) return console.warn('Val is null or undefined')
      return val.toString().toUpperCase()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/TransactionSummary/TransactionSummary.js